import { Installation } from 'src/Libs/installations/models'
import { hasAccessToDirectMarketing } from '../../utils'
import { UserData } from '@e3dc-react/shell/Types'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'

interface Ai360Access {
  hasAi360TariffBannerAccess: boolean
  hasAi360PowerFixAccess: boolean
  hasAi360PowerShareAccess: boolean
}

/**
 * Determine if user has access to the ai360 tariffs banner and to each ai360 tariff (power fix / power share).
 * Each one is toggled by its own feature flag on top of the shared direct marketing access check.
 */
const useAi360Access = (installation?: Installation, userData?: UserData): Ai360Access => {
  const {
    featureFlags: { isAi360TariffBannerEnabled, isAi360FixedTariffEnabled, isAi360SharedTariffEnabled },
  } = useFeatureFlagsContext()
  const hasDirectMarketingAccess = hasAccessToDirectMarketing(installation, userData)

  return {
    hasAi360TariffBannerAccess: hasDirectMarketingAccess && isAi360TariffBannerEnabled,
    hasAi360PowerFixAccess: hasDirectMarketingAccess && isAi360FixedTariffEnabled,
    hasAi360PowerShareAccess: hasDirectMarketingAccess && isAi360SharedTariffEnabled,
  }
}

export default useAi360Access
